// for add employee state
export const ADD_EMPLOYEE_EDUCATION_DATA = "add_employee_education_data";
